import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPostBulkChangeBodyDto {
  name: string;
  pages: {
    templateName: string;
    sheetName: string;
    excludedCols: string[];
    searchObject: Record<string, unknown>;
  }[];
}

export class IBulkChange {
  id: string;
  name: string;
  userId: number;
  count: number;
  progress: number;
  pages: {
    templateName: string;
    sheetName: string;
    excludedCols: string[];
    searchObject: Record<string, unknown>;
  }[];
  errorData: Record<string, unknown>[];
  /** Üretilen dosya boyutu (byte); rapor sunucusu akışlı üretimle yazar */
  fileSize?: number | null;
  status: string;
  createdAt: string;
  uploadedAt: string;
  updatedAt: string;
}

export interface ColumnsFormProps {
  defaultColumns: string[];
  additionalColumns: string[];
}

export class IBulkChangeResponse {
  @Type(() => IBulkChange)
  result: IBulkChange;
}

export class IBulkChangeListResponse extends IPagination {
  @Type(() => IBulkChange)
  results: IBulkChange[];
}

export class IBulkChangeFileResponse {
  url: string;
}

export class IBulkChangeQueryDto extends IQueryPaginationDto {
  userId?: string | number;
  name?: string;
}
